import React, { useState } from "react";
import "../styles/admin.scss";
import Grid from "@mui/material/Grid2";
import { Button, CircularProgress, TextField, Typography, InputAdornment, IconButton } from "@mui/material";
import instance from "../../Utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";


const AdminForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [open, setOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);



  const [errors, setErrors] = useState({
    otp: "",
    email: "",
    confirmPassword: "",
    newPassword: "",
  });


  const sendOtp = async () => {
    let tempErrors = {};

    if (!email.trim()) {
      tempErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        tempErrors.email = "Enter a valid email";
      }
    }

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) return;
    const encodedEmail = encodeURIComponent(email);
    try {
      setLoading(true)
      const response = await instance.get(`/Admin/SendOtp?email=${encodedEmail}`);
      toast.success(response.data.message);
      setOpen(true)
    }
    catch (err) {
      toast.error(err.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const resetPassword = async () => {
    let tempErrors = {};

    if (!newPassword?.trim() || newPassword.length < 6) {
      tempErrors.newPassword = "Password must be at least 6 characters";
    }

    if (confirmPassword !== newPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
    }

    if (!otp.trim()) {
      tempErrors.otp = "OTP is required";
    }

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) return;


    try {
      setLoading(true)
      const response = await instance.patch('/Admin/ResetPasswordOtp', {
        email,
        newPassword,
        confirmPassword,
        otp
      });

      if (response.status === 200) {
        toast.success(response.data.message);
        navigate('/admin/login');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setLoading(false)
    }
  };

  return (
    <React.Fragment>
      <section className="admin-login-container">
        <div className="login-img">
          <div className="login-bgd"></div>
        </div>
        <div className="login-fields">
          <Grid container direction="column" spacing={2} className='login-fields-container'>
            <div className="login-header">
              <Typography variant="h5">
                Forgot <span className="sub-heading">Password</span>
              </Typography>
              <Typography>Enter email to get otp</Typography>
            </div>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="login-textfiled">
                <TextField
                  type="email"
                  label="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value.toLowerCase());
                    setErrors({ ...errors, email: "" });
                  }}
                  placeholder="Enter your email"
                  variant="outlined"
                  fullWidth
                  required
                  disabled={open}
                  error={!!errors.email}
                  helperText={errors.email}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      ...(errors.email && {
                        "& fieldset": {
                          borderColor: "red !important",
                        },
                      }),
                    },
                  }}
                />
              </div>
            </Grid>
            {open ?
              <>
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                  <div className="login-textfiled">
                    <TextField
                      type="otp"
                      label="otp"
                      value={otp}
                      onChange={(e) => {
                        setOtp(e.target.value);
                        setErrors({ ...errors, otp: "" });
                      }}
                      placeholder="Enter otp"
                      variant="outlined"
                      fullWidth
                      required
                      error={!!errors.otp}
                      helperText={errors.otp}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          ...(errors.otp && {
                            "& fieldset": {
                              borderColor: "red !important",
                            },
                          }),
                        },
                      }}
                    />
                  </div>
                </Grid>

                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                  <div className="login-textfiled">
                    <TextField
                      type={showNewPassword ? "text" : "password"}
                      label="New Password"
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                        setErrors({ ...errors, newPassword: "" });
                      }}
                      placeholder="Enter your New Password"
                      variant="outlined"
                      fullWidth
                      required
                      error={!!errors.newPassword}
                      helperText={errors.newPassword}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          ...(errors.newPassword && {
                            "& fieldset": {
                              borderColor: "red !important",
                            },
                          }),
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowNewPassword(!showNewPassword)}>
                              {showNewPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </Grid>

                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                  <div className="login-textfiled">
                    <TextField
                      type={showConfirmPassword ? "text" : "password"}
                      label="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        setErrors({ ...errors, confirmPassword: "" });
                      }}
                      placeholder="Enter your Confirmed Password"
                      variant="outlined"
                      fullWidth
                      required
                      error={!!errors.confirmPassword}
                      helperText={errors.confirmPassword}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          ...(errors.confirmPassword && {
                            "& fieldset": {
                              borderColor: "red !important",
                            },
                          }),
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                              {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </Grid>

              </>
              :
              null
            }
            <Button
              variant="outlined"
              onClick={open ? resetPassword : sendOtp}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={16} sx={{ color: "#fff" }} />
              ) : open ? (
                "Verify Otp"
              ) : (
                "Send Otp"
              )}
            </Button>

          </Grid>
        </div>
      </section>
    </React.Fragment>
  );
};

export default AdminForgotPassword;
